import { API_URLS } from "./apiConstants";
import axiosInstance from "./api";
import { API_PATH } from "../constants/ApiPath";

export const getChatUsersListRestApiEndpoint = (config) => {
  return axiosInstance.get(API_URLS.USERS_LIST, config);
};

export const getChatListFromDjango = (config) => {
  return axiosInstance.get(API_URLS.CHAT_LIST, config);
};

export const postSendInternalMessageToDjango = (data) => {
  return axiosInstance.post(API_URLS.INTERNAL_MESSAGE, data);
};

export const getWarehouseList = (params) => {
  return axiosInstance.get(API_URLS.WAREHOUSE, { params });
};

export const postCreateWarehouse = (data) => {
  return axiosInstance.post(API_URLS.WAREHOUSE, data);
};

export const getAnalyticsDahboard = (params) => {
  return axiosInstance.get(API_URLS.DASHBOARD_ANALYTICS, { params });
};

export const postSparesTrack = (data, params) => {
  return axiosInstance.post(API_URLS.SPARE_TRACK, data, { params });
};

export const getSparesTracking = (params) => {
  return axiosInstance.get(API_URLS.SPARE_TRACK_DETAIL, { params });
};

export const postProductTracking = (data) => {
  return axiosInstance.post(API_URLS.PRODUCT_TRACK, data);
};

export const getProductMovementHistory = (params) => {
  return axiosInstance.get(API_URLS.PRODUCT_MOVEMENT_HISTORY, { params });
};

export const postSpareReturn = (data) => {
  return axiosInstance.post(API_URLS.SPARE_RETURN, data);
};

export const getDOASpares = (params) => {
  return axiosInstance.get(API_URLS.DOA_SPARES, { params });
};

export const getVendorDataResponse = (params) => {
  return axiosInstance.get(API_URLS.VENDOR_DATA_RESPONSE, { params });
};

// Will be used to create vendor data response only for testing purpose, will be removed later
export const postVendorDataResponse = (data) => {
  return axiosInstance.post(API_URLS.VENDOR_DATA_RESPONSE, data);
};

export const postVendorDataApprove = (data) => {
  return axiosInstance.post(API_URLS.VENDOR_DATA_APPROVE, data);
};

export const deleteEngineerById = () => {
  return axiosInstance.post(API_URLS.ENGINEER_DELETE);
};

export const getSowSubtypeActions = (params) => {
  return axiosInstance.get(API_URLS.SOW_SUBTYPE_ACTIONS, { params });
};

export const addNewSowSubtypeAction = (data) => {
  return axiosInstance.post(API_URLS.ADD_NEW_SOW_SUBTYPE_ACTION, data);
};

export const getVendorPastInteractions = (params) => {
  return axiosInstance.get(API_URLS.VENDOR_PAST_INTERACTIONS, { params });
};

function toRawQueryString(params) {
  const search = new URLSearchParams();
  Object.keys(params || {}).forEach((key) => {
    const value = params[key];
    if (value === undefined || value === null || value === "") {
      return;
    }
    search.append(key, String(value));
  });
  return search.toString();
}

export const getTicketInteractions = (params) => {
  const qs = toRawQueryString(params);
  const url = qs
    ? `${API_URLS.TICKET_INTERACTIONS}?${qs}`
    : API_URLS.TICKET_INTERACTIONS;
  return axiosInstance.get(url);
};

export const getPincodePartners = (params) => {
  return axiosInstance.get(API_URLS.PINCODE_PARTNERS, { params });
};

export const closeTasks = (data) => {
  return axiosInstance.post(API_URLS.CLOSE_TASK, data);
};

// Finance API endpoints
export const getProjectsList = (params) => {
  return axiosInstance.get(API_URLS.PROJECTS_LIST, { params });
};

export const getPaymentPartners = (params) => {
  return axiosInstance.get(API_URLS.PAYMENT_PARTNERS, { params });
};

export const getWorkOrders = (params) => {
  return axiosInstance.get(API_URLS.WORK_ORDERS, { params });
};

export const createInvoiceRequest = (data) => {
  return axiosInstance.post(API_URLS.INVOICE_REQUEST, data);
};

export const patchInvoiceRequest = (id) => {
  return axiosInstance.patch(`${API_URLS.INVOICE_REQUEST}${id}/`);
};

export const getInvoiceRequests = (params) => {
  return axiosInstance.get(API_URLS.INVOICE_REQUEST, { params });
};

export const generatePartnerInvoice = (data) => {
  return axiosInstance.post(API_URLS.GENERATE_PARTNER_INVOICE, data, {
    responseType: "blob",
  });
};

export const resendPartnerInvoice = (data) => {
  return axiosInstance.post(API_URLS.RESEND_PARTNER_INVOICE, data);
};

export const regeneratePartnerInvoice = (data) => {
  return axiosInstance.post(API_URLS.REGENERATE_PARTNER_INVOICE, data);
};

export const retryPartnerInvoice = (data) => {
  return axiosInstance.post(API_URLS.RETRY_PARTNER_INVOICE, data);
};
